"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardComparisonRow_1 = require("./CardComparisonRow");
exports.default = CardComparisonRow_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/CardComparisonRow/index.js
// module id = 1308
// module chunks = 8